module.exports = __webpack_public_path__ + "static/media/student-summary-bottom.275dcba4.png";